import React from 'react';
import WName, {WArticle} from '../WName';
import QL from './QuestionLink';
import PL from '../problems/ProblemLink';
import AL from '../angles/AngleLink';
import NW from '../neologisms/NewWord';
import OML from '../ormaybe/OrMaybeLink';
import LRL from '../longreads/LongReadLink';
import {E1, E2, Qual, TLDR} from '../common';

export const silly = {
  name: "silly",
  prelude: <span>
    If you want AnyoneElse<sup>™</sup> to take you <i>seriously</i>, <NW>zyzzyva</NW>…
  </span>,
  question: <span>What the (f*cking Black) Hell is up with all the silly (and, frankly, <i>stupid</i>) shite?</span>,
  answerPreview: <div className="answer-preview">
[Under construction]
  </div>,
//  answer: <div className="answer-text">
//  </div>,
};

